export default __webpack_public_path__ + "static/media/shared-icon.9cb91eec.svg";